export const PICKING_DELIVERY_ORDERS_PATH =
  '/operations/picking-delivery-orders'

/**
 * Batch / picklist ID deep-links into the Picking Delivery Order list,
 * pre-filtered to that batch. Query param must be `picklistId` because that is
 * what the list page's ALLOWED_QUERY_KEYS whitelist accepts — `batchId` is
 * silently dropped.
 */
export const buildBatchLink = (batchId) =>
  `${PICKING_DELIVERY_ORDERS_PATH}?picklistId=${batchId}&offset=0&page=1`
